import React from 'react';
import { ErrorMessage } from 'anf-core-react';

const ContentError = ({ error, isDesktop = true }) => {
  if (!error?.value) return null;
  const className = `add-to-bag-form-wrapper_error-message${isDesktop ? '_desktop' : ''}`;
  return (
    <div className={className} data-testid="add-to-bag-error-message">
      <ErrorMessage>
        <span data-property={error.key}>{error.value}</span>
      </ErrorMessage>
    </div>
  );
};

export default ContentError;
